module.exports = __webpack_public_path__ + "img/smartMeeting.89eeebcb.svg";